onVideoLoadedData.$inject = ['CoreDirectivesService'];

export default function onVideoLoadedData(CoreDirectivesService) {
    // loadeddata event means that the first/current frame of data has been loaded, but not necessarily the whole file
    return CoreDirectivesService.getEventCallbackDirectiveConfig('loadeddata', 'onVideoLoadedData');
}
